export const environment = {
  name: 'predprod',
  production: false,
  api: 'https://pkapi.predprod.cloud.vkplay.ru/',
  apiPathPrimary: '',
  serverApi: 'http://portal-gateway.predprod-microservices:8080/',
  cookiesDomain: 'predprod.playkey.net',
  platformsBindDomain: 'https://predprod.playkey.net',
  client: {
    mac: 'https://cdnmgc.playkey.net/clientdownload.aspx?file=MacClient-beta/Playkey.pkg',
    windows: 'https://cdnmgc.playkey.net/clientdownload.aspx?file=windows-desktop/Beta/PlaykeySetup.exe',
  },
  gaCounter: 'UA-52416734-2',
  yaMetrika: 39624610,
  stripeCode: 'pk_test_Ox7i9cHoxpM9UsrDjZQZzT9U',
  partnerUrls: {
    'TTK': 'https://ttkbeta.playkey.net'
  },
  captchaPublicKey: '6Lf3VDEUAAAAAByqcc6dbbG4_Y4rmefeBb3EEhUa',
};
